export default "__VITE_ASSET__Cy3CglHr__"